import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from 'react';

import {
	BancoBciIcon,
	BancoBiceIcon,
	BancoChinaConstructionIcon,
	BancoConsorcioIcon,
	BancoCoopeuchIcon,
	BancoCopecPayIcon,
	BancoDoBrasilIcon,
	BancoEdwardsIcon,
	BancoEstadoIcon,
	BancoFalabellaIcon,
	BancoGlobal66Icon,
	BancoHsbcIcon,
	BancoInternacionalIcon,
	BancoItauIcon,
	BancoJpMorganIcon,
	BancoLaPolarIcon,
	BancoLosHeroesIcon,
	BancoMercadoPagoIcon,
	BancoOfChinaIcon,
	BancoRabobankIcon,
	BancoRipleyIcon,
	BancoSantanderIcon,
	BancoScotiabankIcon,
	BancoSecurityIcon,
	BancoTappIcon,
	BancoTenpoIcon,
} from '../../../../assets/svg/banks';
import { BancoBtgIcon } from '../../../../assets/svg/banks/bancoBtg';
import { ETPayButton } from '../../../../components/button';
import { Modal } from '../../../../components/modal';
import { Spinner } from '../../../../components/spinner';
import { useFloatingAlert } from '../../../../hooks/useFloatingAlert';
import { useMerchant } from '../../../../hooks/useMerchant';
import { Beneficiary } from '../../../../models/payouts';
import { PayoutsService } from '../../../../services/payouts';
import { Values } from '../table';
import ContentModal from './contentModal';
import {
	Button,
	ErrorModalContent,
	ErrorModalDescription,
	ErrorModalTitle,
	ModalContainer,
	ModalFooter,
	ModalHeader,
	ModalStep,
	ModalTitle,
} from './styles';

interface EditModalProps {
	beneficiary: Beneficiary;
	state: Values;
	setState: Dispatch<SetStateAction<Values>>;
	onClose: () => void;
}

const SubTitleSteps = [
	'Edita la información del beneficiario',
	'Verifica la información del beneficiario',
];

export interface Options {
	label: string;
	value: string;
	show: boolean;
	icon: JSX.Element;
}

export const paymentTypeOptions: Options[] = [
	{
		label: 'Banco BCI/MACH',
		value: '016',
		show: true,
		icon: <BancoBciIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco Bice',
		value: '028',
		show: true,
		icon: <BancoBiceIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco Consorcio',
		value: '053',
		show: true,
		icon: <BancoConsorcioIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco de Chile - Edwards Citi',
		value: '001',
		show: true,
		icon: <BancoEdwardsIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco del Estado de Chile',
		value: '012',
		show: true,
		icon: <BancoEstadoIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco Falabella',
		value: '051',
		show: true,
		icon: <BancoFalabellaIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco Internacional',
		value: '009',
		show: true,
		icon: <BancoInternacionalIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco Itaú',
		value: '039',
		show: true,
		icon: <BancoItauIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco Ripley',
		value: '055',
		show: true,
		icon: <BancoRipleyIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco Santander-Banefe',
		value: '037',
		show: true,
		icon: <BancoSantanderIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco Security',
		value: '049',
		show: true,
		icon: <BancoSecurityIcon width="18px" height="18px" />,
	},
	{
		label: 'Coopeuch',
		value: '672',
		show: true,
		icon: <BancoCoopeuchIcon width="18px" height="18px" />,
	},
	{
		label: 'CopecPay',
		value: '741',
		show: true,
		icon: <BancoCopecPayIcon width="18px" height="18px" />,
	},
	{
		label: 'Global66',
		value: '738',
		show: true,
		icon: <BancoGlobal66Icon width="18px" height="18px" />,
	},
	{ label: 'HSBC', value: '031', show: true, icon: <BancoHsbcIcon width="18px" height="18px" /> },
	{
		label: 'La Polar Prepago',
		value: '697',
		show: true,
		icon: <BancoLaPolarIcon width="18px" height="18px" />,
	},
	{
		label: 'Mercado Pago EmisoraS.A.',
		value: '875',
		show: true,
		icon: <BancoMercadoPagoIcon width="18px" height="18px" />,
	},
	{
		label: 'Prepago Los Héroes',
		value: '729',
		show: true,
		icon: <BancoLosHeroesIcon width="18px" height="18px" />,
	},
	{
		label: 'Rabobank',
		value: '045',
		show: true,
		icon: <BancoRabobankIcon width="18px" height="18px" />,
	},
	{
		label: 'Scotiabank',
		value: '014',
		show: true,
		icon: <BancoScotiabankIcon width="18px" height="18px" />,
	},
	{
		label: 'TAPP Caja LosAndes',
		value: '732',
		show: true,
		icon: <BancoTappIcon width="18px" height="18px" />,
	},
	{
		label: 'Tenpo PrepagoS',
		value: '730',
		show: true,
		icon: <BancoTenpoIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco BTG Pactual Chile',
		value: '059',
		show: true,
		icon: <BancoBtgIcon width="18px" height="18px" />,
	},
	{
		label: 'Banco do Brasil',
		value: '017',
		show: true,
		icon: <BancoDoBrasilIcon width="18px" height="18px" />,
	},
	{
		label: 'Bank of China',
		value: '061',
		show: true,
		icon: <BancoOfChinaIcon width="18px" height="18px" />,
	},
	{
		label: 'China Construction Bank AG Chile',
		value: '061',
		show: true,
		icon: <BancoChinaConstructionIcon width="18px" height="18px" />,
	},
	{
		label: 'JP Morgan ChaseBank',
		value: '041',
		show: true,
		icon: <BancoJpMorganIcon width="18px" height="18px" />,
	},
];

const EditModal = ({ beneficiary, state, setState, onClose }: EditModalProps) => {
	const [beneficiarySelected, setBeneficiarySelected] = useState<Beneficiary>(beneficiary);
	const { merchantSelected } = useMerchant();
	const { handleShowAlert } = useFloatingAlert();
	const [disabledSubmit, setDisabledSubmit] = useState<boolean>(true);
	const [steps, setSteps] = useState<number>(1);
	const [countRetry, setCountRetry] = useState<number>(0);

	const addCountRetry = () => {
		setCountRetry((prevCount) => {
			const newCount = prevCount + 1;
			if (newCount < 3) {
				setState({
					...state,
					loading: false,
					error: true,
					errorMessage: 'Hubo un error al editar el beneficiario.',
					retryFunction: handleEditRequest,
				});
			} else {
				setState({
					...state,
					loading: false,
					error: true,
					errorMessage: 'Lo sentimos, superó la cantidad de reintentos.',
					retryFunction: onClose,
				});
			}
			return newCount;
		});
	};

	const resetCountRetry = () => {
		setCountRetry(0);
	};

	const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setBeneficiarySelected((prev: Beneficiary) => ({ ...prev, [name]: value }));
	};

	const handleClearInput = () => {
		setBeneficiarySelected((prev: Beneficiary) => ({
			...prev,
			account: '',
			bankName: '',
			bankSbifNumber: '',
		}));
	};

	const handleEditRequest = async () => {
		setState({ ...state, loading: true });
		try {
			await PayoutsService.editBeneficiary({
				merchantCode: merchantSelected?.code as string,
				beneficiary: {
					rut: beneficiarySelected.rut,
					name: beneficiarySelected.name,
					email: beneficiarySelected.email,
					account: beneficiarySelected.account,
					sbif: beneficiarySelected.bankSbifNumber,
					merchantId: merchantSelected?.id as number,
				},
			});
			setState({ ...state, loading: true });
			resetCountRetry();
			handleShowAlert({
				message: 'Beneficiario modificado exitosamente',
				type: 'success',
			});
			onClose();
		} catch (error) {
			handleShowAlert({
				message: 'Hubo un problema al eliminar el beneficiario',
				type: 'error',
			});
			addCountRetry();
		}
	};

	const handleClose = () => {
		if (steps > 1) {
			setSteps(steps - 1);
		} else {
			resetCountRetry();
			onClose();
		}
	};
	const nextStep = () => {
		if (steps < 2) {
			setSteps(steps + 1);
		} else {
			handleEditRequest();
		}
	};

	useEffect(() => {
		if (
			beneficiarySelected.rut !== '' &&
			beneficiarySelected.name !== '' &&
			beneficiarySelected.email !== '' &&
			beneficiarySelected.bankName !== '' &&
			beneficiarySelected.account !== ''
		) {
			setDisabledSubmit(false);
		} else {
			setDisabledSubmit(true);
		}
	}, [beneficiarySelected]);

	const renderContentModalByState = () => {
		if (state.loading) {
			return (
				<Modal
					show={true}
					type="medium"
					title="Procesando petición"
					allowCloseModal={false}
					onClose={onClose}
				>
					<Spinner />
				</Modal>
			);
		} else if (state.error) {
			return (
				<Modal show={true} type="medium" title="Error" onClose={onClose}>
					<ErrorModalContent>
						<ErrorModalTitle>Ha ocurrido un error</ErrorModalTitle>
						<ErrorModalDescription>
							{state.errorMessage ||
								'Lo sentimos, hubo un error con el proceso. Porfavor, inténtalo nuevamente'}
						</ErrorModalDescription>
						<ETPayButton
							title={countRetry < 3 ? 'Reintentar' : 'Cerrar'}
							color="secondary"
							onClick={state.retryFunction}
						/>
					</ErrorModalContent>
				</Modal>
			);
		} else {
			return (
				<Modal title="Agenda" show={true} type="medium" allowCloseModal={true} onClose={onClose}>
					<ModalContainer>
						<ModalHeader>
							<ModalStep>PASO {steps} DE 2</ModalStep>
							<ModalTitle>{SubTitleSteps[steps - 1]}</ModalTitle>
						</ModalHeader>
						<ContentModal
							steps={steps}
							beneficiarySelected={beneficiarySelected}
							setBeneficiarySelected={setBeneficiarySelected}
							handleChangeInput={handleChangeInput}
							handleClearInput={handleClearInput}
						/>
						<ModalFooter>
							<Button onClick={handleClose}>{steps === 1 ? 'Descartar' : 'Regresar'}</Button>
							<Button onClick={() => nextStep()} outboundColor disabled={disabledSubmit}>
								{steps < 2 ? 'Siguiente' : 'Guardar Cambios'}
							</Button>
						</ModalFooter>
					</ModalContainer>
				</Modal>
			);
		}
	};
	return <>{renderContentModalByState()}</>;
};

export default EditModal;
